import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { Authorize } from './shared/authorize.model';

@Component({
  selector: 'authorize',
  templateUrl: './authorize.component.html',
})
export class AuthorizeComponent {

  title = 'authorize.title';
  isStaff = this.store.state.isStaff;
  progressBar = this.progress.authorize;
  authorize: Authorize = this.store.state.consent.authorize;

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) { }

  back() {
    this.router.navigate([this.navigation.authorize.back]);
  }

  next() {
    this.store.state.consent.authorize = this.authorize;
    this.router.navigate([this.navigation.authorize.next]);
  }
}
